export default __webpack_public_path__ + "static/media/brandon-kase.e3cebf58.jpeg";